// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"22":"18d16729","710":"0ab9dee6","776":"c39811af"}[chunkId] + ".css";
};